<template>
  <div class="radio-box-1 mb-3">
    <h5 class="radio-box-1-title">{{ inputConfig.title }}</h5>
    <p v-html="inputConfig.description"></p>
    <div class="form-check form-check-inline radio-box-1-input-wrapper" v-for="(option,index) in options">
      <input v-model="formAnswer[inputConfig.id]" :required="inputConfig.required" class="form-check-input radio-box-1-input" type="radio"
             :name="`radio_group_${inputConfig.id}`" :id="`${inputConfig.id}_${index}`" :value="option.id">
      <label class="form-check-label mr-1 radio-box-1-label" :for="`${inputConfig.id}_${index}`">{{ option.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioBox1",
  props: {
    inputConfig: {},
    formAnswer: {}
  },
  computed: {
    options() {
      return this.inputConfig.options
    },
  },
}
</script>

<style scoped>

</style>